module.exports = __webpack_public_path__ + "img/btnlogo.a4b9137c.jpg";